import { QueryGetMyOrderInClasseQuery } from 'graphql/generated/graphql';
import { CSVCommandesType, CommandeDef } from 'types/commande/commande.def';
import { formatDate } from 'helpers/date/formatDate';
import { formatCommandStatus } from 'helpers/commande/formatCommand';
import { getCommandeDefFromQuery } from '../transformApiResponse/commande';

export function formatCommandes(
  data: QueryGetMyOrderInClasseQuery
): CommandeDef[] {
  return data?.getMyOrdersInClasse?.commandes?.map(c =>
    getCommandeDefFromQuery(c)
  );
}

export function formatCsvCommandes(
  data: QueryGetMyOrderInClasseQuery
): CSVCommandesType {
  return data?.getMyOrdersInClasse?.commandes?.map(c => ({
    'Numéro de commande': c.attributes?.numerocommande,
    Date: formatDate(new Date(c.attributes?.createdAt)),
    'Nom facturation':
      c.attributes?.client?.data?.attributes.prenom +
      ' ' +
      c.attributes?.client?.data?.attributes.nom,
    'Adresse facturation': `${c.attributes?.client?.data?.attributes.adressefacturation}  ${c.attributes?.client?.data?.attributes.villefacturation} ${c.attributes?.client?.data?.attributes.cpfacturation}`,
    'Mail facturation': c.attributes?.client?.data?.attributes.mail,
    'Téléphone facturation': c.attributes?.client?.data?.attributes.tel,
    'Client pro': c.attributes?.client?.data?.attributes.clientpro
      ? 'Oui'
      : 'Non',
    'Total TTC (port inclus + ONG)': `${c.attributes?.prixTotal} €`,
    'Statut de paiement': formatCommandStatus(c.attributes?.status),
    'Type livraison': !c.attributes?.client?.data?.attributes.livraisonhorslycee
      ? 'Lycée'
      : c.attributes?.client?.data?.attributes.affilie
      ? 'Point relais'
      : 'Hors lycée',
    'Statut livraison': c.attributes?.livraison?.status?.length
      ? c.attributes?.livraison.status
      : 'Information non disponible',
    'Participation ONG': c.attributes?.customerContributedToTheOng
      ? 'Oui'
      : 'Non'
  }));
}
